import { Z_INDEX_NAV_COMPONENT_DEFAULT } from '../../../constants/z_index';
export const getStyle = () => {
  return {
    blockSize: '394px',
    inlineSize: '240px',
    position: 'absolute',
    insetBlockStart: 'calc(var(--global-nav-height, 86px) + 16px)',
    insetInlineEnd: 32,
    background: 'transparent',
    zIndex: Z_INDEX_NAV_COMPONENT_DEFAULT
  };
};